import React, { useEffect, useState, useRef, us } from 'react';
import '../ImportProduct.css';
import { useHistory, Redirect } from 'react-router-dom';
import {
    makeStyles, Paper, Button, CircularProgress
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import clsx from 'clsx';
import { v4 as uuidv4 } from 'uuid';
import db, { storage } from '../../../Backend/firebase/firebase';

import CustomAlert from '../../CustomAlert';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import * as XLSX from 'xlsx'

const useStyles = makeStyles((theme) => ({
    root: {

    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
        padding: '20px'
    },
}));

function ImportProductAndPurchase() {
    const { handleSubmit } = useForm();
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { userData } = CheckUserProvider();
    const fileInput = useRef(null);
    const history = useHistory();
    const [isUploading, setIsUploading] = useState(false);
    const [excelJsonRecord, setExcelJsonRecord] = useState(null);
    var batch = db.batch()

    const readUploadFile = (e) => {
        e.preventDefault();
        try {
            if (e.target.files) {
                // setIsUploading(true);
                const files = e.target.files;
                const reader = new FileReader();
                const rABS = !!reader.readAsBinaryString;
            
                reader.onload = (e) => {
                    /* Parse data */
                    const bstr = e.target.result;
                    const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true });
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    /* Convert array of arrays */
                    const data = XLSX.utils.sheet_to_json(ws, {
                        raw: false,
                        header: ws ? 0 : 1,
                        dateNF: "dd/mm/yyyy"
                    });
                    /* Update state */
                    console.log(JSON.stringify(data, null, 2));
                    setExcelJsonRecord(data)
                    setIsUploading(false);
                };
            
                if (rABS) {
                    reader.readAsBinaryString(files[0]);
                } else {
                    reader.readAsArrayBuffer(files[0]);
                };
            } else {
                setIsUploading(false);
            }
        } catch (error) {
            setIsUploading(false);
        }
    }

    const onSubmit = async () => {
        console.log("excelJsonRecord",excelJsonRecord)

        if(excelJsonRecord && excelJsonRecord != null) {
            let excelJson = excelJsonRecord.map(function (obj) {
                const uniqueId = uuidv4();
    
                obj['userId'] = userData.uid; 
                obj['uniqueId'] = uniqueId;
                obj['ProductAndPurchasePostedDateTime'] = new Date();
    
                obj['StockAsPerPrimaryPack'] = obj['Stock (As per Primary Pack)']; 
                delete obj['Stock (As per Primary Pack)'];

                obj['MRPAsPerPrimaryPack'] = obj['MRP (as per Primary Pack)']; 
                delete obj['MRP (as per Primary Pack)'];

                obj['SellingPriceAsPerPrimaryPack'] = obj['Selling Price (as per Primary pack)']; 
                delete obj['Selling Price (as per Primary pack)'];
         
                return obj;
            });
            try {
                console.log("excelJson",excelJson)
                setIsLoading(true);
                await excelJson.map(async (doc)=> {
                    const collectionRef = await db.collection('ProductAndPurchase').doc();
                    batch.set(collectionRef, doc);
                });
                batch.commit().then(() => {
                    setNotificationMessage('Product And Purchase Record created successfully.');
                    setOpenNotify(true);
                    setAlertType('success');
                    setIsLoading(false);
                    setTimeout(routeToPages, 1500);
                }).catch((error)=> {
                    console.error(error);
                    setNotificationMessage('Something went wrong, Please try again later!!');
                    setOpenNotify(true);
                    setAlertType('error');
                    setIsLoading(false);
                    history.push('/retailer/create-product-and-purchase');
                });
            }  catch (error) {
                console.error(error);
                setNotificationMessage('Something went wrong, Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
                history.push('/retailer/create-product-and-purchase');
            }
        } else {
            setNotificationMessage('Please Upload CSV or Excel File!!');
            setOpenNotify(true);
            setAlertType('error');
        }
    };

    const routeToPages = () => {
        window.location.pathname = '/retailer/all-product-and-purchase';
    }

    return (
        <>
            <div className="createProduct mt-2">
                <Helmet>
                    <meta name="description" content="Creating new product page." />
                    <title>Create new product and purchase | Kaipsool Pharmatech</title>
                </Helmet>
                <Paper className={fixedHeightPaper}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            
                            <div className="col-md-10 mb-2">
                                <div className="form-group">
                                    Upload Excel <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                    <div className="d-flex align-items-center">
                                        <input type="file" accept=".csv,.xlsx,.xlsm" ref={fileInput}
                                            onChange={readUploadFile} style={{ display: 'none' }} />
                                        <Button
                                            variant="contained"
                                            color="default"
                                            startIcon={<CloudUploadIcon />}
                                            disabled={isUploading}
                                            onClick={() => fileInput.current.click()}>
                                            Upload Excel File <small>(accept csv,.xlsx)</small>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-10 text-left mt-3">
                                <div className="d-flex justify-content-left">
                                    <div className="pp-2">
                                        <Button type="submit" variant="contained" className="registerEmp__btnLogin">
                                            {isLoading ? <CircularProgress size={18} /> : 'Import From Excel'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </Paper>
            </div>
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default ImportProductAndPurchase

